import React from 'react';

type MaterialIconProps = {
  name: string;
  className?: string;
  filled?: boolean;
  title?: string;
};

function MaterialIcon({ name, className = '', filled = false, title }: MaterialIconProps) {
  return (
    <span
      className={`material-symbols-rounded ${className}`.trim()}
      style={{
        fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' 500, 'GRAD' 0, 'opsz' 24`,
      }}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      {name}
    </span>
  );
}

export default MaterialIcon;
